import ar from './i18n/ar.json';

export namespace TranslationUtils {

  export async function useTranslation(locale: string) {
    const data = locale == 'ar' ? ar : undefined;
    return (text: string): string => data?.translation[text] ?? text;
  }

}
